import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { h } from './chunk-FY4TNGN6.js';

function r(_x, _x2) {
  return _r.apply(this, arguments);
}

function _r() {
  _r = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, o) {
    var _yield$Promise$all, _yield$Promise$all2, a;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([import('./dotlottie-state-machine-manager-7AXSPEV3.js')]);

          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            a = _yield$Promise$all2[0].DotLottieStateMachineManager;

            if (t.length) {
              _context.next = 7;
              break;
            }

            throw h("No state machines available inside this .lottie!");

          case 7:
            return _context.abrupt("return", new a(t, o));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _r.apply(this, arguments);
}

export { r as a };